import { useFlashbarStateStore } from '../stores/notifications/flashbarStateStore'

export const ACCESS_MANAGEMENT_FLASHBAR_PREFIX = 'access-management:'

type FlashbarActions = Pick<
	ReturnType<typeof useFlashbarStateStore>,
	'addItem' | 'removeItem'
>

export const showAccessManagementNotification = (
	{ addItem, removeItem }: FlashbarActions,
	{
		type,
		header,
		content
	}: {
		type: 'success' | 'error'
		header: string
		content: string
	}
) => {
	const id = `${ACCESS_MANAGEMENT_FLASHBAR_PREFIX}${Date.now()}`
	addItem({
		id,
		type,
		header,
		content,
		dismissible: true,
		dismissLabel: 'Dismiss notification',
		onDismiss: () => removeItem(id)
	})
}
